import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../pages/Home.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: 'Fred Dope | EDM DJ & Music Producer',
      metaTags: [
      { property: 'og:title', content: 'Fred Dope | EDM DJ & Music Producer' },
      { property: 'og:image', content: 'https://www.freddope.com' + require('@/assets/logo-circle.png') },
      { property: 'og:url', content: 'https://www.freddope.com' },
      { property: 'og:type', content: 'website' }
    ]
    }
  },
  {
    path: '/ravecast',
    name: 'RaveCast',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "ravecast" */ '../pages/RaveCast.vue'),
    meta: {
      title: 'Fred Dope | RaveCast - Your best source for EDM',
      metaTags: [
      { property: 'og:title', content: 'Fred Dope | RaveCast - Your best source for EDM' },
      { property: 'og:image', content: 'https://www.freddope.com' + require('@/assets/hero-img.png') },
      { property: 'og:url', content: 'https://www.freddope.com/ravecast' },
      { property: 'og:type', content: 'article' }
    ]
    }
  },
  {
    path: '/music',
    name: 'Music',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "music" */ '../pages/Music.vue'),
    meta: {
      title: 'Fred Dope | All my music',
      metaTags: [
      { property: 'og:title', content: 'Fred Dope | All My Music' },
      { property: 'og:image', content: 'https://www.freddope.com' + require('@/assets/logo.png') },
      { property: 'og:url', content: 'https://www.freddope.com/music' },
      { property: 'og:type', content: 'article' }
    ]
    }
  },
  {
    path: '/contacts',
    name: 'Contacts',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "contacts" */ '../pages/Contacts.vue'),
    meta: {
      title: 'Fred Dope | Contact Me',
    }
  },
  {
    path: '/post/:id',
    name: 'Post',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "post" */ '../pages/Post.vue'),
      meta: {
      metaTags: [
      { property: 'og:title', content: 'Fred Dope | EDM DJ & Music Producer ' },
      { property: 'og:image', content: 'https://www.freddope.com' + require('@/assets/logo.png') },
      { property: 'og:url', content: 'https://www.freddope.com' },
      { property: 'og:type', content: 'article' }
    ]
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_BASE_URL,
  routes
})

router.beforeEach((toRoute, fromRoute, next) => {
  window.document.title = toRoute.meta && toRoute.meta.title ? toRoute.meta.title : 'Fred Dope';

  const nearestWithTitle = toRoute.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = toRoute.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  const previousNearestWithMeta = fromRoute.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if(nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  } else if(previousNearestWithMeta) {
    document.title = previousNearestWithMeta.meta.title;
  }

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if(!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
  // Add the meta tags to the document head.
  .forEach(tag => document.head.appendChild(tag));

  next();
});

export default router
